var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import eventBus from '../../utils/fresh-table';
import moment from 'moment';
import request from '../../utils/request';
import { setSession } from '../../utils/storage';
import { toYuan } from '../../utils/unit-conversion';
export default Vue.extend({
    name: 'insuranceTablePage',
    components: {},
    props: {
        sourceUrl: {
            type: String,
            default: '',
            required: true,
        },
        method: {
            type: String,
            default: 'get',
        },
        hasPaging: {
            type: Boolean,
            default: true,
        },
        queryTitleText: {
            type: String,
            default: false,
        },
        isShowDateModel: {
            type: Boolean,
            default: false,
        },
        buttons: {
            type: Array,
            default: function () {
                return [];
            },
            required: false,
            validator: function (value) {
                var pass = true;
                if (!value)
                    return pass;
                for (var i = 0; i < value.length; i++) {
                    var item = value[i];
                    item.type = item.type || 'primary';
                    if (!item.label) {
                        pass = false;
                        break;
                    }
                }
                return pass;
            },
        },
        tableOptions: {
            type: Array,
            default: function () {
                return [];
            },
            required: true,
            validator: function (value) {
                var pass = true;
                for (var i = 0; i < value.length; i++) {
                    var item = value[i];
                    if (!item.label && !item.prop && (!item.name && !item.data)) {
                        pass = false;
                        break;
                    }
                }
                return pass;
            },
        },
        noDataTitle: {
            type: String,
            required: false,
        },
        noFilterTitle: {
            type: String,
            required: false,
        },
        noDataTxt: {
            type: String,
            required: false,
        },
        importUrl: {
            type: String,
            required: false,
        },
        importBtn: {
            type: Boolean,
            required: false,
        },
        selection: {
            type: Boolean,
            default: function () {
                return false;
            },
            required: false,
        },
        isExpand: {
            type: Boolean,
            default: function () {
                return false;
            },
            required: false,
        },
        expandData: {
            type: Array,
            default: function () {
                return [];
            },
            required: false,
            validator: function (value) {
                var pass = true;
                for (var i = 0; i < value.length; i++) {
                    var item = value[i];
                    if (!item.label && !item.value) {
                        pass = false;
                        break;
                    }
                }
                return pass;
            },
        },
        repeatPolicy: {
            type: Array,
            default: function () {
                return [];
            },
        },
    },
    data: function () {
        var _this = this;
        return {
            file: '',
            select: '',
            allSelect: '',
            selectAmout: 0.0,
            selectNum: 0,
            isApply: false,
            checked: false,
            multipleSelection: [],
            value: '',
            queryForm: {
                startDate: '',
                endDate: '',
            },
            tableData: [],
            agree: 1,
            totalSelect: 0,
            totalItems: 30,
            currentPage: 1,
            currentPageSize: 20,
            timeRange: [],
            isFilter: false,
            startDateVolidate: {
                disabledDate: function (time) {
                    var endDate = _this.queryForm.endDate;
                    if (endDate) {
                        return time.getTime() > Date.parse(endDate);
                    }
                },
            },
            endDateVolidate: {
                disabledDate: function (time) {
                    var startDate = _this.queryForm.startDate;
                    if (startDate) {
                        return time.getTime() < Date.parse(startDate);
                    }
                },
            },
        };
    },
    computed: {
        btnConfig: function () {
            var btnConfig = this.filterConfig.filter(function (f) { return f.type === 'btnFilter'; });
            for (var _i = 0, btnConfig_1 = btnConfig; _i < btnConfig_1.length; _i++) {
                var temp = btnConfig_1[_i];
                temp['info'].forEach(function (item, index) {
                    item['isActive'] = false;
                    if (index === 0) {
                        item['isActive'] = true;
                    }
                });
            }
            return btnConfig;
        },
        hasFilter: function () {
            return (this.searchConfig.length > 0 ||
                this.selectConfig.length > 0 ||
                this.rangeConfig.length > 0);
        },
    },
    created: function () {
        eventBus.$on('freshTable', this.requestData);
        // if (this.previousRequest) {
        this.requestData();
        // }
    },
    methods: {
        setCurrent: function (rows) {
            var _this = this;
            rows.forEach(function (row) {
                _this.$refs.singleTable.toggleRowSelection(row);
            });
            this.multipleSelection = rows;
        },
        queryByDate: function () {
            // 通过日期查询
            this.$refs['queryForm'].validate(function (valid) {
                if (!valid) {
                    return;
                }
            });
            var _a = this.queryForm, startDate = _a.startDate, endDate = _a.endDate;
            this.requestData({
                signStartTime: startDate && moment(startDate).format('YYYY-MM-DD'),
                signEndTime: endDate && moment(endDate).format('YYYY-MM-DD'),
            });
        },
        requestData: function (params) {
            var _this = this;
            if (params === void 0) { params = {}; }
            if (this.hasPaging) {
                params = __assign({ pageNo: this.currentPage, pageSize: this.currentPageSize }, params);
            }
            request({
                url: this.sourceUrl,
                method: this.method,
                data: __assign({}, params),
            }).then(function (res) {
                if (!res)
                    return;
                // if (res.errorCode) return
                if (!res.errorCode && res.data) {
                    _this.tableData = res.data || [];
                    _this.totalItems = res.totalItemCount;
                    _this.tableData.forEach(function (item) {
                        item.isDisabled = false;
                    });
                }
            });
        },
        toggleSelection: function (isSelect) {
            var _this = this;
            this.$refs.singleTable.clearSelection();
            if (isSelect) {
                this.tableData.forEach(function (row) {
                    _this.$refs.singleTable.toggleRowSelection(row);
                });
            }
            else {
                this.$refs.singleTable.clearSelection();
            }
        },
        handleSelectionChange: function (val) {
            var valLen = val.length, tableLen = this.tableData.length;
            this.multipleSelection = val;
            this.totalSelect = valLen;
            this.allSelect = valLen > 0 && valLen === tableLen ? true : false;
            this.isApply = valLen > 4 ? true : false;
            this.autoAmount(val);
        },
        disabledRow: function (row, index) {
            var repeatPolicy = this.repeatPolicy;
            if (repeatPolicy.includes(row.insPolicyCode)) {
                row.isDisabled = true;
                return false;
            }
            row.isDisabled = false;
            return true;
        },
        autoAmount: function (selectData) {
            var amount = 0;
            selectData.forEach(function (item) {
                if (!item.isDisabled) {
                    amount += item.loanAmount;
                }
            });
            this.selectAmout = toYuan(amount).toFixed(2);
        },
        btnClick: function (cb) {
            if (cb && typeof cb === 'function') {
                cb();
            }
        },
        actionBtn: function (cb) {
            if (cb && typeof cb === 'function') {
                cb();
            }
        },
        btnFilter: function (val, key, btnIndex) {
            for (var _i = 0, _a = this.btnConfig[btnIndex].info; _i < _a.length; _i++) {
                var temp = _a[_i];
                temp.isActive = false;
                if (temp.btnKey === val) {
                    temp.isActive = true;
                }
            }
            this.filterOptions[key] = val;
            this.doFilter();
        },
        doFilter: function () {
            this.isFilter = true;
            this.currentPage = 1;
            for (var _i = 0, _a = this.searchConfigSelect; _i < _a.length; _i++) {
                var temp = _a[_i];
                this.filterOptions[temp.value] = '';
                if (this.searchSelect === temp.value) {
                    this.filterOptions[this.searchSelect] = this.searchOption;
                }
            }
            for (var i in this.filterOptions) {
                if (this.filterOptions[i] === '') {
                    delete this.filterOptions[i];
                }
            }
            this.requestData(this.filterOptions);
        },
        doClear: function () {
            this.filterOptions = {};
            this.timeRangeStart = '';
            this.timeRangeEnd = '';
            this.searchOption = '';
            this.currentPage = 1;
            this.currentPageSize = 20;
            this.$emit('clearTransType');
            // if (this.previousRequest) {
            this.requestData();
            // } else {
            //   this.tableData = []
            // }
            // this.requestData()
            // this.$refs['filterOptions'].resetFields()
        },
        pageChange: function (currentPage) {
            this.currentPage = currentPage;
            this.requestData(__assign({}, this.filterOptions, { currentPage: currentPage, currentPageSize: this.currentPageSize }));
        },
        pageSizeChange: function (currentPageSize) {
            this.currentPageSize = currentPageSize;
            this.requestData(__assign({}, this.filterOptions, { showCount: currentPageSize }));
        },
        timeChange: function (timeRange, date, item) {
            // if (timeRange != null && timeRange != undefined && timeRange.length > 0) {
            //   item.startTimeKey = item.startTimeKey || 'startTime'
            //   item.endTimeKey = item.endTimeKey || 'endTime'
            //   item.apiFormat = item.apiFormat || 'yyyy-MM-dd'
            //   this.filterOptions[item.startTimeKey] = moment(timeRange[0]).format(item.apiFormat)
            //   this.filterOptions[item.endTimeKey] = moment(timeRange[1]).format(item.apiFormat)
            // } else {
            //   this.filterOptions[item.startTimeKey] = ''
            //   this.filterOptions[item.endTimeKey] = ''
            // }
            // if (this.timeRangeEnd && this.timeRangeStart) {
            //   this.doFilter()
            // }
            // if ((!this.timeRangeEnd) || (!this.timeRangeStart)) {
            //   return
            // }
        },
        timeChangeEnd: function (timeRange, date, item) {
            var dateEnd = moment(timeRange).format(item.apiFormat);
            this.filterOptions[item.endTimeKey] = Math.round(moment(dateEnd).valueOf() / 1000).toString();
            this.timeChange();
        },
        timeChangeStart: function (timeRange, date, item) {
            var dateStart = moment(timeRange).format(item.apiFormat);
            this.filterOptions[item.startTimeKey] = Math.round(moment(dateStart).valueOf() / 1000).toString();
            this.timeChange();
        },
        gotoImport: function (path) {
            this.$router.push({
                path: path,
            });
        },
        applyLoan: function () {
            var selectPolicy = [], selectAmout = this.selectAmout;
            for (var _i = 0, _a = this.multipleSelection; _i < _a.length; _i++) {
                var temp = _a[_i];
                var insPolicyCode = temp.insPolicyCode, insCompanyCode = temp.insCompanyCode, policyType = temp.policyType;
                selectPolicy.push({
                    insPolicyCode: insPolicyCode,
                    insCompanyCode: insCompanyCode,
                    policyType: policyType,
                });
            }
            setSession('policyMation', {
                selectPolicy: selectPolicy,
                selectAmout: selectAmout,
            });
            this.$router.push({ name: 'applyLoanSure' });
        },
        rowStyle: function (_a) {
            var row = _a.row, rowIndex = _a.rowIndex;
            var repeatPolicy = this.repeatPolicy;
            if (repeatPolicy.includes(row.insPolicyCode) ||
                row.status === 'TERMINATED' ||
                row.status === 'STOPPED') {
                return 'background: #f4f5f7;color: #666F83';
            }
        },
    },
});
